import { Navigate } from 'react-router-dom';
import { useParams } from "react-router";
import SessionReload from "./component-assets/SessionReload.jsx";
import { iAmHigherAuthority } from "../libs.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import TasksEhr from "./TasksEhr.jsx";
import TasksEhrPage from "../pages/tasks/ehr/TasksEhrPage.jsx";
import TestComponent from "./TestComponent.jsx";
import TasksMaint from "./TasksMaint.jsx";
import { getSession, getEhrInfo } from "../services/session";
import { useForceLight } from "../contexts/ThemeContext.jsx";

const Tasks = (props) => {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let tasksContent, dData, paramVars, bData;
    paramVars = useParams();

    /* /tasks/ehr is a V2 page, but /tasks/maintenance still renders the
       unthemed V1 TasksMaint. Flag rather than a conditional call, so the
       hook order stays stable. See docs/DARK_MODE_PLAN.md section 3. */
    useForceLight(paramVars.dType === "maintenance");

    dData = getSession();

    if (paramVars.dType === "ehr"){
        /* The nav link's rule (NavigationV2 "EHR Tasks"): an active EHR integration on this
           campus AND role weight above 10. Checked here too so the page can't be opened by
           URL when the link is hidden (docs/EHR_TASKS_REPORT_PLAN.md decision 1). */
        if (!(getEhrInfo().active && iAmHigherAuthority(10, dData?.role_weight))){
            return <Navigate to={"/"} />;
        }
        tasksContent = isV2 ? <TasksEhrPage /> : <TasksEhr />;
        // tasksContent = <TestComponent />
    }else if (paramVars.dType === "maintenance"){
        if (dData?.campusData[dData.acnt.toString()]?.is_cloud){
            tasksContent = <TasksMaint />
        }else{
            return <Navigate to={"/"} />
        }
    }else{
        tasksContent = (
            <div>
                <h3>Page not found. 404</h3>
            </div>
        );
    }

    return (getEhrInfo().active || iAmHigherAuthority(10, dData.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {tasksContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Tasks;